function getUTMParameters() {
    const params = new URLSearchParams(window.location.search);
    const utmParams = {};
    
    params.forEach((value, key) => {
        if (key.startsWith("utm_")) {
            utmParams[key] = value;
        }
    });
    
    return utmParams;
}

function setUTMCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + JSON.stringify(value) + expires + "; path=/";
}

function getUTMCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let cookie of cookies) {
        let [cookieName, cookieValue] = cookie.split("=");
        if (cookieName === name) {
            return JSON.parse(cookieValue);
        }
    }
    return null;
}

function appendUTMToLinks() {
    const utmParams = getUTMCookie("utm_data");
    if (!utmParams) return;
    
    document.querySelectorAll('a[href^="https://www.hyatt.com"]').forEach(link => {
        const url = new URL(link.href);
        Object.entries(utmParams).forEach(([key, value]) => {
            url.searchParams.set(key, value);
        });
        link.href = url.toString();
    });
}

(function() {
    const utmParams = getUTMParameters();
    if (Object.keys(utmParams).length > 0) {
        setUTMCookie("utm_data", utmParams, 30);
    }
    appendUTMToLinks();
})();
 